import PropertyTypeContainer from './containers/PropertyTypeContainer'

export default PropertyTypeContainer
